
import PriceFormat from "../../../../utils/priceFormat";
import DashboardStat from "../../../dashboard/DashboardStat";
import Card from "../../../shared/Card/Card";
import useListingStats from '../../../../data/useListingStats';
import UnlistedStatsTable from "./UnlistedStatsTable";

export function UnlistedTableStats() {
  const { unlistedStats } = useListingStats();

  if (unlistedStats.isLoading) return null;

  const stats = unlistedStats.data?.data;

  if (!stats) return null;

  return (
    <Card bodyClassName="p-4 grid grid-cols-1 lg:grid-cols-3 gap-4" title="Unlisted Stats" collapsible >

      {/* General Stats */}

      <div className="grid gap-2 grid-cols-1 lg:grid-cols-2">

        <DashboardStat title={stats.awaitingListing.toString()} desc={"Awaiting Listing"} color={"blue"} />
        <DashboardStat title={stats.notLocated.toString()} desc={"Not Located"} color={"blue"} />
        <DashboardStat title={stats.missingPrice.toString()} desc={"Missing Price"} color={"yellow"} />
        <DashboardStat title={stats.missingMpn.toString()} desc={"Missing MPN"} color={"yellow"} />
        <DashboardStat title={stats.notImaged.toString()} desc={"Not Imaged"} color={"green"} />
        <DashboardStat title={PriceFormat(stats.unlistedValue)} desc={"Unlisted Value"} small="Of Priced Parts" color={"green"} />

      </div>

      {/* Top Catgeories */}

      <div className="flex flex-col gap-2 lg:col-span-2">

        <UnlistedStatsTable unlistedStats={stats} />

      </div>

    </Card>
  )
}